<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">List of Crawl Schedules</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
                  :pagination="pagin"
                  :columns="DomainCrawlScheduleListColumn"
                  :dataSource="data"
                  :tableSize="tableSize">
            <template slot="start_date" slot-scope="{ record }">
              <p class="time-text">
                <time>
                  {{ record.start_date | dateString }}
                </time>
              </p>
              <p class="time-text">
                <time>
                  {{ record.start_date | timeString }}
                </time>
              </p>
            </template>
            <template slot="last_run_date" slot-scope="{ record }">
              <template v-if="record.last_run_date >= '0000-00-00 00:00:00'">
                <p class="time-text">
                  <time>
                    {{ record.last_run_date | dateString }}
                  </time>
                </p>
                <p class="time-text">
                  <time>
                    {{ record.last_run_date | timeString }}
                  </time>
                </p>
              </template>
              <template v-else>
                -
              </template>
            </template>
            <template slot="interval" slot-scope="{ record }">
              <template v-if="record.interval == 'P7D'">Weekly</template>
              <template v-else>Daily</template>
            </template>
            <template slot="policy_id" slot-scope="{ record }">
              <template v-for="policy in policies">
                <router-link :to="'/policy/' + policy.id" :key="policy.id" v-if="policy.id == record.policy_id">{{ policy.name }} - {{ policy.description }}</router-link>
              </template>
              <template v-if="!record.policy_id">
                -
              </template>
            </template>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item @click="onEdit(record)">
                    <img class="mr-2" src="@assets/icon/operation.svg" />
                    Edit
                  </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)">
                      <img class="mr-2" src="@assets/icon/delete.svg" />
                      Delete
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>

  import { DomainCrawlScheduleListColumn } from "../columnsTable/DomainCrawlScheduleListColumn";
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import DomainService from "../services/Domain.service";
  import WebpageService from "../../Webpages/services/webpage.service";
  import PolicyService from "../../Policy/services/policy.service";

  export default {
    name: 'DomainCrawlScheduleList',
    data() {
      return {
        DomainCrawlScheduleListColumn,
        PAGE_OPTIONS,
        policies: [],
        data: [],
        filterData: [],
        contactGroups: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: 5,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        },
      };
    },
    mounted() {
      this.fetchList();
    },
    methods: {
      elSizeChange() {},
      async fetchList() {
        try {
          const responseData = await DomainService.fetchDomainCrawlSchedules();

          this.data = (responseData || []).map((item, index) => ({
            ...item,
            index: index + 1,
          }));

          this.pagin.total = this.data.length;

          this.policies = await PolicyService.getList();

        } catch (error) {
          this.$showErrorMessage('HTTP error received from web server!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          },
        });
      },
      onDelete(record) {
        DomainService.deleteDomainCrawlSchedule(record.id).then(() => {
          this.$showSuccessMessage('Deleted crawl schedule');
          this.fetchList();
        });
      },
      onEdit(record) {
        this.$router.push({
          path: '/domain/edit-crawl-schedule/' + record.id,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
  }
</style>
